"use strict";

function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
function _defineProperty(e, t, i) {
  return t in e ? Object.defineProperty(e, t, {
    value: i,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = i, e;
}
function _classCallCheck(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(e, t) {
  if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return !t || "object" != typeof t && "function" != typeof t ? e : t;
}
function _inherits(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}
Object.defineProperty(exports, "__esModule", {
  value: !0
});
var _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  },
  _slicedToArray = function () {
    function e(e, t) {
      var i = [],
        s = !0,
        o = !1,
        n = void 0;
      try {
        for (var r, a = e[Symbol.iterator](); !(s = (r = a.next()).done) && (i.push(r.value), !t || i.length !== t); s = !0);
      } catch (e) {
        o = !0, n = e;
      } finally {
        try {
          !s && a.return && a.return();
        } finally {
          if (o) throw n;
        }
      }
      return i;
    }
    return function (t, i) {
      if (Array.isArray(t)) return t;
      if (Symbol.iterator in Object(t)) return e(t, i);
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
  }(),
  _extends = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var i = arguments[t];
      for (var s in i) Object.prototype.hasOwnProperty.call(i, s) && (e[s] = i[s]);
    }
    return e;
  },
  _createClass = function () {
    function e(e, t) {
      for (var i = 0; i < t.length; i++) {
        var s = t[i];
        s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(e, s.key, s);
      }
    }
    return function (t, i, s) {
      return i && e(t.prototype, i), s && e(t, s), t;
    };
  }(),
  _react = require("react"),
  _react2 = _interopRequireDefault(_react),
  _propTypes = require("prop-types"),
  _globals = require("./globals"),
  inOut = (0, _propTypes.shape)({
    make: _propTypes.func,
    duration: _propTypes.number.isRequired,
    delay: _propTypes.number.isRequired,
    forever: _propTypes.bool,
    count: _propTypes.number.isRequired,
    style: _propTypes.object.isRequired,
    reverse: _propTypes.bool
  }),
  propTypes = {
    collapse: _propTypes.bool,
    collapseEl: _propTypes.element,
    cascade: _propTypes.bool,
    wait: _propTypes.number,
    force: _propTypes.bool,
    disabled: _propTypes.bool,
    appear: _propTypes.bool,
    enter: _propTypes.bool,
    exit: _propTypes.bool,
    fraction: _propTypes.number,
    refProp: _propTypes.string,
    innerRef: _propTypes.func,
    onReveal: _propTypes.func,
    unmountOnExit: _propTypes.bool,
    mountOnEnter: _propTypes.bool,
    inEffect: inOut.isRequired,
    outEffect: (0, _propTypes.oneOfType)([inOut, (0, _propTypes.oneOf)([!1])]).isRequired,
    ssrReveal: _propTypes.bool,
    collapseOnly: _propTypes.bool,
    ssrFadeout: _propTypes.bool
  },
  defaultProps = {
    fraction: .2,
    refProp: "ref"
  },
  contextTypes = {
    transitionGroup: _propTypes.object
  },
  RevealBase = function (e) {
    function t(e, i) {
      _classCallCheck(this, t);
      var s = _possibleConstructorReturn(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e, i));
      return s.isOn = void 0 === e.when || !!e.when, s.state = {
        collapse: e.collapse ? t.getInitialCollapseStyle(e) : void 0,
        style: {
          opacity: s.isOn && !e.ssrReveal || !e.outEffect ? void 0 : 0
        }
      }, s.savedChild = !1, s.isShown = !1, _globals.observerMode ? s.handleObserve = s.handleObserve.bind(s) : (s.revealHandler = s.makeHandler(s.reveal), s.resizeHandler = s.makeHandler(s.resize)), s.saveRef = s.saveRef.bind(s), s;
    }
    return _inherits(t, e), _createClass(t, [{
      key: "saveRef",
      value: function (e) {
        this.childRef && this.childRef(e), this.props.innerRef && this.props.innerRef(e), this.el !== e && (this.el = e && "offsetHeight" in e ? e : void 0, this.observe(this.props, !0));
      }
    }, {
      key: "invisible",
      value: function () {
        this && this.el && (this.savedChild = !1, this.isShown || (this.setState({
          hasExited: !0,
          collapse: this.props.collapse ? _extends({}, this.state.collapse, {
            visibility: "hidden"
          }) : null,
          style: {
            opacity: 0
          }
        }), !_globals.observerMode && this.props.collapse && window.document.dispatchEvent(_globals.collapseend)));
      }
    }, {
      key: "animationEnd",
      value: function (e, t, i) {
        var s = this,
          o = i.forever,
          n = i.count,
          r = i.delay,
          a = i.duration;
        if (!o) {
          var l = function () {
            s && s.el && (s.animationEndTimeout = void 0, e.call(s));
          };
          this.animationEndTimeout = window.setTimeout(l, r + (a + (t ? a : 0) * n));
        }
      }
    }, {
      key: "getDimensionValue",
      value: function () {
        return this.el.offsetHeight + parseInt(window.getComputedStyle(this.el, null).getPropertyValue("margin-top"), 10) + parseInt(window.getComputedStyle(this.el, null).getPropertyValue("margin-bottom"), 10);
      }
    }, {
      key: "collapse",
      value: function (e, t, i) {
        var s = i.duration + (t.cascade ? i.duration : 0),
          o = this.isOn ? this.getDimensionValue() : 0,
          n = void 0,
          r = void 0;
        if (t.collapseOnly) n = i.duration / 3, r = i.delay;else {
          var a = s >> 2,
            l = a >> 1;
          n = a, r = i.delay + (this.isOn ? 0 : s - a - l), e.style.animationDuration = s - a + (this.isOn ? l : -l) + "ms", e.style.animationDelay = i.delay + (this.isOn ? a - l : 0) + "ms";
        }
        return e.collapse = {
          height: o,
          transition: "height " + n + "ms ease " + r + "ms",
          overflow: t.collapseOnly ? "hidden" : void 0
        }, e;
      }
    }, {
      key: "animate",
      value: function (e) {
        if (this && this.el && (this.unlisten(), this.isShown !== this.isOn)) {
          this.isShown = this.isOn;
          var t = !this.isOn && e.outEffect,
            i = e[t ? "outEffect" : "inEffect"],
            s = "style" in i && i.style.animationName || void 0,
            o = void 0;
          e.collapseOnly ? o = {
            hasAppeared: !0,
            hasExited: !1,
            style: {
              opacity: 1
            }
          } : ((e.outEffect || this.isOn) && i.make && (s = i.make), o = {
            hasAppeared: !0,
            hasExited: !1,
            collapse: void 0,
            style: _extends({}, i.style, {
              animationDuration: i.duration + "ms",
              animationDelay: i.delay + "ms",
              animationIterationCount: i.forever ? "infinite" : i.count,
              opacity: 1,
              animationName: s
            }),
            className: i.className
          }), this.setState(e.collapse ? this.collapse(o, e, i) : o), t ? (this.savedChild = _react2.default.cloneElement(this.getChild()), this.animationEnd(this.invisible, e.cascade, i)) : this.savedChild = !1, this.onReveal(e);
        }
      }
    }, {
      key: "onReveal",
      value: function (e) {
        e.onReveal && this.isOn && (this.onRevealTimeout && (this.onRevealTimeout = window.clearTimeout(this.onRevealTimeout)), e.wait ? this.onRevealTimeout = window.setTimeout(e.onReveal, e.wait) : e.onReveal());
      }
    }, {
      key: "componentWillUnmount",
      value: function () {
        this.unlisten(), _globals.ssr && (0, _globals.disableSsr)();
      }
    }, {
      key: "handleObserve",
      value: function (e, t) {
        _slicedToArray(e, 1)[0].intersectionRatio > 0 && (t.disconnect(), this.observer = null, this.reveal(this.props, !0));
      }
    }, {
      key: "observe",
      value: function (e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
        if (this.el && _globals.observerMode) {
          if (this.observer) {
            if (!t) return;
            this.observer.disconnect();
          } else if (t) return;
          this.observer = new IntersectionObserver(this.handleObserve, {
            threshold: e.fraction
          }), this.observer.observe(this.el);
        }
      }
    }, {
      key: "reveal",
      value: function (e) {
        var t = this,
          i = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
        _globals.globalHide || (0, _globals.hideAll)(), this && this.el && (e || (e = this.props), _globals.ssr && (0, _globals.disableSsr)(), this.isOn && this.isShown && void 0 !== e.spy ? (this.isShown = !1, this.setState({
          style: {}
        }), window.setTimeout(function () {
          return t.reveal(e);
        }, 200)) : i || this.inViewport(e) || e.force ? this.animate(e) : _globals.observerMode ? this.observe(e) : this.listen());
      }
    }, {
      key: "componentDidMount",
      value: function () {
        var e = this;
        if (this.el && !this.props.disabled) {
          this.props.collapseOnly || ("make" in this.props.inEffect && this.props.inEffect.make(!1, this.props), void 0 !== this.props.when && this.props.outEffect && "make" in this.props.outEffect && this.props.outEffect.make(!0, this.props));
          var i = this.context.transitionGroup,
            s = i && !i.isMounting ? !("enter" in this.props && !1 === this.props.enter) : this.props.appear;
          return this.isOn && ((void 0 !== this.props.when || void 0 !== this.props.spy) && !s || _globals.ssr && !_globals.fadeOutEnabled && !this.props.ssrFadeout && this.props.outEffect && !this.props.ssrReveal && t.getTop(this.el) < window.pageYOffset + window.innerHeight) ? (this.isShown = !0, this.setState({
            hasAppeared: !0,
            collapse: this.props.collapse ? {
              height: this.getDimensionValue()
            } : this.state.collapse,
            style: {
              opacity: 1
            }
          }), void this.onReveal(this.props)) : _globals.ssr && (_globals.fadeOutEnabled || this.props.ssrFadeout) && this.props.outEffect && t.getTop(this.el) < window.pageYOffset + window.innerHeight ? (this.setState({
            style: {
              opacity: 0,
              transition: "opacity 1000ms 1000ms"
            }
          }), void window.setTimeout(function () {
            return e.reveal(e.props, !0);
          }, 2e3)) : void (this.isOn && (this.props.force ? this.animate(this.props) : this.reveal(this.props)));
        }
      }
    }, {
      key: "cascade",
      value: function (e) {
        var t = this,
          i = void 0;
        i = "string" == typeof e ? e.split("").map(function (e, t) {
          return _react2.default.createElement("span", {
            key: t,
            style: {
              display: "inline-block",
              whiteSpace: "pre"
            }
          }, e);
        }) : _react2.default.Children.toArray(e);
        var s = this.props[this.isOn || !this.props.outEffect ? "inEffect" : "outEffect"],
          o = s.duration,
          n = s.reverse,
          r = i.length,
          a = 2 * o;
        this.props.collapse && (a = parseInt(this.state.style.animationDuration, 10), o = a / 2);
        var l = n ? r : 0;
        return i = i.map(function (e) {
          return "object" === (void 0 === e ? "undefined" : _typeof(e)) && e ? _react2.default.cloneElement(e, {
            style: _extends({}, e.props.style, t.state.style, {
              animationDuration: Math.round((0, _globals.cascade)(n ? l-- : l++, 0, r, o, a)) + "ms"
            })
          }) : e;
        });
      }
    }, {
      key: "componentWillReceiveProps",
      value: function (e) {
        if (void 0 !== e.when && (this.isOn = !!e.when), e.fraction !== this.props.fraction && this.observe(e, !0), !this.isOn && e.onExited && "exit" in e && !1 === e.exit) return void e.onExited();
        e.disabled || (e.collapse && !this.props.collapse && (this.setState({
          style: {},
          collapse: t.getInitialCollapseStyle(e)
        }), this.isShown = !1), e.when === this.props.when && e.spy === this.props.spy || this.reveal(e), this.onRevealTimeout && !this.isOn && (this.onRevealTimeout = window.clearTimeout(this.onRevealTimeout)));
      }
    }, {
      key: "getChild",
      value: function () {
        if (this.savedChild && !this.props.disabled) return this.savedChild;
        if ("object" === _typeof(this.props.children)) {
          var e = _react2.default.Children.only(this.props.children);
          return "type" in e && "string" == typeof e.type || "ref" !== this.props.refProp ? e : _react2.default.createElement("div", null, e);
        }
        return _react2.default.createElement("div", null, this.props.children);
      }
    }, {
      key: "render",
      value: function () {
        var e = void 0;
        e = this.state.hasAppeared ? !this.props.unmountOnExit || !this.state.hasExited || this.isOn : !this.props.mountOnEnter || this.isOn;
        var t = this.getChild();
        "function" == typeof t.ref && (this.childRef = t.ref);
        var i = !1,
          s = t.props,
          o = s.style,
          n = s.className,
          r = s.children,
          a = this.props.disabled ? n : (this.props.outEffect ? _globals.namespace : "") + (this.state.className ? " " + this.state.className : "") + (n ? " " + n : "") || void 0,
          l = void 0;
        "function" == typeof this.state.style.animationName && (this.state.style.animationName = this.state.style.animationName(!this.isOn, this.props)), this.props.cascade && !this.props.disabled && r && this.state.style.animationName ? (i = this.cascade(r), l = _extends({}, o, {
          opacity: 1
        })) : l = this.props.disabled ? o : _extends({}, o, this.state.style);
        var p = _extends({}, this.props.props, _defineProperty({
            className: a,
            style: l
          }, this.props.refProp, this.saveRef)),
          h = _react2.default.cloneElement(t, p, e ? i || r : void 0);
        return void 0 !== this.props.collapse ? this.props.collapseEl ? _react2.default.cloneElement(this.props.collapseEl, {
          style: _extends({}, this.props.collapseEl.style, this.props.disabled ? void 0 : this.state.collapse),
          children: h
        }) : _react2.default.createElement("div", {
          style: this.props.disabled ? void 0 : this.state.collapse,
          children: h
        }) : h;
      }
    }, {
      key: "makeHandler",
      value: function (e) {
        var t = this,
          i = function () {
            e.call(t, t.props), t.ticking = !1;
          };
        return function () {
          t.ticking || ((0, _globals.raf)(i), t.ticking = !0);
        };
      }
    }, {
      key: "inViewport",
      value: function (e) {
        if (!this.el || window.document.hidden) return !1;
        var i = this.el.offsetHeight,
          s = window.pageYOffset - t.getTop(this.el),
          o = Math.min(i, window.innerHeight) * (_globals.globalHide ? e.fraction : 0);
        return s > o - window.innerHeight && s < i - o;
      }
    }, {
      key: "resize",
      value: function (e) {
        this && this.el && this.isOn && this.inViewport(e) && (this.unlisten(), this.isShown = this.isOn, this.setState({
          hasExited: !this.isOn,
          hasAppeared: !0,
          collapse: void 0,
          style: {
            opacity: this.isOn || !e.outEffect ? 1 : 0
          }
        }), this.onReveal(e));
      }
    }, {
      key: "listen",
      value: function () {
        _globals.observerMode || this.isListener || (this.isListener = !0, window.addEventListener("scroll", this.revealHandler, {
          passive: !0
        }), window.addEventListener("orientationchange", this.revealHandler, {
          passive: !0
        }), window.document.addEventListener("visibilitychange", this.revealHandler, {
          passive: !0
        }), window.document.addEventListener("collapseend", this.revealHandler, {
          passive: !0
        }), window.addEventListener("resize", this.resizeHandler, {
          passive: !0
        }));
      }
    }, {
      key: "unlisten",
      value: function () {
        !_globals.observerMode && this.isListener && (window.removeEventListener("scroll", this.revealHandler, {
          passive: !0
        }), window.removeEventListener("orientationchange", this.revealHandler, {
          passive: !0
        }), window.document.removeEventListener("visibilitychange", this.revealHandler, {
          passive: !0
        }), window.document.removeEventListener("collapseend", this.revealHandler, {
          passive: !0
        }), window.removeEventListener("resize", this.resizeHandler, {
          passive: !0
        }), this.isListener = !1), this.onRevealTimeout && (this.onRevealTimeout = window.clearTimeout(this.onRevealTimeout)), this.animationEndTimeout && (this.animationEndTimeout = window.clearTimeout(this.animationEndTimeout));
      }
    }], [{
      key: "getInitialCollapseStyle",
      value: function (e) {
        return {
          height: 0,
          visibility: e.when ? void 0 : "hidden"
        };
      }
    }, {
      key: "getTop",
      value: function (e) {
        for (; void 0 === e.offsetTop;) e = e.parentNode;
        for (var t = e.offsetTop; e.offsetParent; t += e.offsetTop) e = e.offsetParent;
        return t;
      }
    }]), t;
  }(_react2.default.Component);
RevealBase.propTypes = propTypes, RevealBase.defaultProps = defaultProps, RevealBase.contextTypes = contextTypes, RevealBase.displayName = "RevealBase", exports.default = RevealBase, module.exports = exports.default;